/**
 * Shared Overall Status chart/table computation for WaveAccordion and
 * DeploymentAccordion (CONIOTPOR-445: FOTA Lifecycle vs KPI data source toggle).
 */

export const OVERALL_STATUS_SOURCE = {
  FOTA_LIFECYCLE: 'fotaLifecycle',
  KPI: 'kpi',
};

/**
 * Builds the Overall Status doughnut chart data and Done/Error/In progress
 * status table from raw machine counts. Shape/labels/colors match what was
 * previously inlined in WaveAccordion.js and DeploymentAccordion.js.
 */
export function buildOverallStatusFromCounts({ done = 0, error = 0, executing = 0 }) {
  const totalDone = done + error + executing;
  const donePct = totalDone ? Math.round((done / totalDone) * 100) : 0;
  const errorPct = totalDone ? Math.round((error / totalDone) * 100) : 0;
  const executingPct = totalDone ? Math.round((executing / totalDone) * 100) : 0;

  const statusInfo = [
    { status: 'Done', count: done, percentage: donePct },
    { status: 'Error', count: error, percentage: errorPct },
    { status: 'In progress', count: executing, percentage: executingPct },
    { status: 'Total', count: totalDone },
  ];

  const chartData = {
    labels: ['Done', 'Error', 'In progress'],
    datasets: [
      {
        label: 'Deployment Status',
        data: [donePct, errorPct, executingPct],
        backgroundColor: ['green', 'red', 'orange'],
        hoverOffset: 3,
      },
    ],
  };

  return { statusInfo, chartData };
}

/**
 * Derives Done/In progress/Error machine counts from FOTA Lifecycle data,
 * using the existing status mapping: status === 7 -> done,
 * 1 <= status < 7 -> in progress, error list entries -> error.
 */
export function buildLifecycleCounts({ successData, errorData }) {
  const successDataArray = Array.isArray(successData) ? successData : [];
  const errorDataArray = Array.isArray(errorData) ? errorData : [];

  const done = successDataArray
    .filter((item) => item.status === 7)
    .reduce((acc, item) => acc + (item?.machineCount || 0), 0);

  const executing = successDataArray
    .filter((item) => item.status >= 1 && item.status < 7)
    .reduce((acc, item) => acc + (item?.machineCount || 0), 0);

  const error = errorDataArray
    .reduce((acc, item) => acc + (item?.machineCount || 0), 0);

  return { done, executing, error };
}
